import * as React from "react"
import classNames from "classnames"
import Element from "@bappweb/element"

const BigLogoAkbank = ({ className, ...rest }: { className?: string }) => {
  return (
    <Element
      {...rest}
      type="svg"
      xmlns="http://www.w3.org/2000/svg"
      width={704}
      height={88}
      viewBox="0 0 704 88"
      fill="none"
      className={classNames("bapp-logo", className)}>
      <Element
        type="path"
        d="M527.962 0L577.049 61.3483V0H604.745V87.9997H563.943L514.856 26.6513V87.9997H487.16V0H527.962ZM665.702 31.0515H650.988V0.000228571H622.797V87.9999H650.988V56.1943H669.286L704 87.9713V53.064L690.553 40.8572L704 28.4104V0.000228571H697.973L665.702 31.0515ZM333.966 23.5088C333.966 34.0688 328.525 39.223 323.58 41.9888C330.008 43.4973 339.158 49.5316 339.158 63.4858C339.158 79.7029 326.793 88 309.483 88H222.19V0.000342856H306.639C323.702 0.000342856 333.966 9.05174 333.966 23.5088ZM0 0.00411427L0.00224807 0.000685712H36.2299L86.4293 87.9992H54.654L47.3579 74.9261H0V0.00411427ZM35.7365 54.0565L17.807 22.1263L0.00224807 54.0565H35.7365ZM170.013 0.000685712L137.742 31.0508H123.028V0.000685712H94.8376V87.9992H123.028V56.1947H141.328L176.072 87.9992H214.525L162.594 40.8577L206.735 0.000685712H170.013ZM249.887 66.8801H301.075C306.639 66.8801 310.72 64.8687 310.72 59.8401C310.72 54.8116 306.639 52.8001 301.075 52.8001H249.887V66.8801ZM249.887 21.1203H297.737C302.93 21.1203 306.517 23.006 306.517 27.6574C306.517 32.3088 302.93 33.9431 297.737 33.9431H249.887V21.1203ZM392.325 54.057L410.13 22.1257L428.058 54.057H392.325ZM342.126 87.9998L392.325 0.000114285H428.552L478.752 87.9998H446.976L439.681 74.9255H380.579L373.284 87.9998H342.126Z" 
        fill="#DC0005"
       
      />
    </Element>
  )
}

export default BigLogoAkbank
